//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHealthCardInfo } from '@/api/module/index';
import vueEsign from "vue-esign";
import html2canvas from "html2canvas";
import { Dialog, Toast } from "vant";
import { decrypt } from "@/assets/utils/cryptoUtil";
export default {
  data: function data() {
    return {
      serialNo: '',
      data: {},
      url: window.g.VUE_APP_PIC_URL,
      cardStyle: window.g.VUE_APP_HEALTH_CARD_TYPE,
      //模板样式
      hospitalName: window.g.VUE_APP_HOSPITALNAME //医院名称

    };
  },
  created: function created() {
    this.serialNo = this.$route.query.SerialNo;
    this.init();
  },
  methods: {
    decrypt: decrypt,
    init: function init() {
      var _this = this;

      getHealthCardInfo({
        serialNo: this.serialNo
      }).then(function (res) {
        if (res.code == 200) {
          _this.data = res.data;

          if (_this.data.sexId == 1) {
            _this.data.sexId = '男';
          } else if (_this.data.sexId == 2) {
            _this.data.sexId = '女';
          } else {
            _this.data.sexId = '未知';
          }
        }
      });
    },
    //保存图片
    saveImage: function saveImage() {
      var _this2 = this;

      this.isUpload = true; // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等

      html2canvas(this.$refs.creditQrCodeShare, {
        backgroundColor: '#ffffff',
        //画出来的图片有白色的边框,不要可设置背景为透明色（null）
        useCORS: true,
        //支持图片跨域
        scale: window.devicePixelRatio || 1 //设置放大的倍数

      }).then(function (canvas) {
        // 把生成的base64位图片上传到服务器,生成在线图片地址
        var url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
        //将图片下载到本地

        _this2.imgUrl = url;
        var a = document.createElement("a"); // 生成一个a元素

        var event = new MouseEvent("click"); // 创建一个单击事件

        a.download = name || "健康证"; // 设置图片名称没有设置则为默认

        a.href = _this2.imgUrl; // 将生成的URL设置为a.href属性

        a.dispatchEvent(event); // 触发a的单击事件

        _this2.isUpload = false;
      });
    },
    // 根据日期转格式
    getDate: function getDate(date) {
      var date1 = new Date(date);
      var year = date1.getFullYear();
      var month = date1.getMonth() + 1;
      var day = date1.getDate();
      return year + "年" + month + "月" + day + "日";
    }
  }
};